import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import PopularnyObsah from '../model/PopularnyObsah';

const mapToPopularnyObsah = (responseItem): PopularnyObsah => (
  {
    id: responseItem['@id'],
    nazovOdkazu: responseItem.nazovOdkazu,
    odkaz: responseItem.odkaz,
  }
);

export const getPopularnyObsahList = async ():
  Promise<ClientResponse<Array<PopularnyObsah>>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/popularny-obsah/@nodes',
  );

  return {
    data: data.map(responseItem => mapToPopularnyObsah(responseItem)),
    responseCode: status,
  };
};
